export const isTrainingLessonPath = (path: string) => /\.html?(?:$|\?)/i.test(path);
